import type { SVGProps } from "react";
import * as React from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10 14 8.5-8.5 2 2L10 18l-6.5-6.5 2-2L10 14Z"
    />
  </svg>
);
export default SvgCheck;
